import React from 'react';
import { Field, reduxForm, FieldArray } from 'redux-form';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import RenderSelectInput from 'components/forms/RenderSelectInput';
import { Col, Row } from 'reactstrap';
import Button from 'components/buttons/Button';
import isEmpty from 'lodash/isEmpty';

import { TIMEZONE_OPTIONS } from 'constants/schedule';
import { TIME_FORMAT } from 'constants/config';
import RenderFormInput from 'components/forms/RenderFormInput';
import RenderSwitchInput from 'components/forms/RenderSwitchInput';
import RenderDateTimePicker from 'components/forms/RenderDateTimePicker';
import {
  requiredValidator, requiredOptionValidator, handleBlur, minLengthArrayValidator,
} from 'utils/validators';
import { renderDaysToSend, ExcludeDaysArray } from './fieldsArray';


const ScheduleForm = props => (
  <form className="instance-form schedule-create-form" onSubmit={props.handleSubmit}>
    <div className="instance-form__body">

      <Row>
        <Col lg={12} xl={8}>
          {/* eslint-disable jsx-a11y/label-has-for */}
          <label>Schedule name</label>
          <Field
            maxLength="255"
            name="name"
            component={RenderFormInput}
            type="text"
            onBlur={handleBlur}
            validate={[requiredValidator]}
          />
        </Col>
      </Row>

      {/* eslint-disable jsx-a11y/label-has-for */}
      <label>Days of week to send</label>
      <FieldArray
        name="days_to_send"
        validate={values => minLengthArrayValidator(values, 1, 'At least one day should be selected')}
        component={renderDaysToSend}
      />

      <Row>
        <Col xs={12} sm={6}>
          {/* eslint-disable jsx-a11y/label-has-for */}
          <label>Time of day to start sending</label>
          <Field
            name="time_from"
            className="date-picker"
            validate={[requiredValidator]}
            component={RenderDateTimePicker}
            showTimeSelectOnly
            showTimeSelect
            dateFormat={TIME_FORMAT}
            timeFormat="p"
          />
        </Col>

        <Col xs={12} sm={6}>
          {/* eslint-disable jsx-a11y/label-has-for */}
          <label>Time of day to finish sending</label>
          <Field
            name="time_to"
            className="date-picker"
            validate={[requiredValidator]}
            component={RenderDateTimePicker}
            showTimeSelectOnly
            showTimeSelect
            dateFormat={TIME_FORMAT}
            timeFormat="p"
          />
        </Col>

        <Col xs={12} sm={6}>
          {/* eslint-disable jsx-a11y/label-has-for */}
          <label>Timezone</label>
          <Field
            name="timezone"
            placeholder="Timezone"
            validate={[requiredOptionValidator]}
            options={TIMEZONE_OPTIONS}
            component={RenderSelectInput}
          />
        </Col>
      </Row>

      <Row>
        <Col xs={12} sm={6}>
          {/* eslint-disable jsx-a11y/label-has-for */}
          <label>Exclude public US holidays</label>
          <label htmlFor="exclude_us_holidays" className="switch">
            <Field
              maxLength="255"
              onBlur={handleBlur}
              id="exclude_us_holidays"
              name="exclude_us_holidays"
              component={RenderSwitchInput}
            />
          </label>
        </Col>

        <Col xs={12} sm={6}>
          {/* eslint-disable jsx-a11y/label-has-for */}
          <label>Custom day to exclude</label>
          <FieldArray name="excluded_dates" component={ExcludeDaysArray} />
        </Col>
      </Row>

    </div>
    <div className="instance-form__footer">
      {props.toggleModal && (
        <Button type="button" color="secondary" variant="text" onClick={props.toggleModal}>Cancel</Button>
      )}
      <Button
        color="primary"
        variant="contained"
        className="ml-2"
        disabled={props.pristine || props.submitting}
        type="submit"
      >
        Save
      </Button>
    </div>
  </form>
);


ScheduleForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  toggleModal: PropTypes.func,
  initialValues: PropTypes.shape({
    name: PropTypes.string,
  }),
  submitting: PropTypes.bool,
  pristine: PropTypes.bool,
};

ScheduleForm.defaultProps = {
  toggleModal: null,
  submitting: false,
  pristine: true,
  initialValues: {},
};


export default compose(
  connect(
    (state, props) => {
      let initialValues = {
        exclude_us_holidays: false,
        excluded_dates: [],
        days_to_send: [],
      };
      if (!isEmpty(props.initialValues)) {
        initialValues = {
          ...initialValues,
          ...props.initialValues,
        };
      }
      return {
        initialValues,
      };
    },
    {},
  ),
  reduxForm({
    form: 'scheduleForm',
  }),
)(ScheduleForm);
